<div class="d-md-flex align-items-center  py-2" style="background-color: #87858525">
            <span class="d-flex align-items-center pl-3  ">
              <span class="font-weight-bold font-14">{{titolo ?? 'Check'}} &nbsp;&nbsp;&nbsp;</span>
            </span>
</div>

<div class="d-md-flex align-items-center p-3" *ngIf="isNewView" >
  <div class="input-group">
    <ng-multiselect-dropdown [data]="unselectedCheckList()" [(ngModel)]="CheckListSelezionato" [settings]="{idField: 'id', textField:'check', singleSelection:true, singleOutput: true}">
    </ng-multiselect-dropdown>
  </div>
  <button type="button" (click)="addCheck()" class="btn btn-outline-primary  p-1 ml-2" style="min-width: 100px" ><i class="fas fa-plus  font-14 mr-1 "></i>Aggiungi</button>
</div>

<div class="table-responsive" *ngIf="CheckList">
    <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
      <thead>
      <tr>
        <th scope="col" *ngIf="!isNewView">Check</th>
        <th scope="col">{{ isNewView ? titolo : 'Nome' }}</th>
        <th scope="col" *ngIf="hasCampiAggiuntiviCheckbox(CheckList)">{{ isNewView ? '' : 'Campi' }}</th>
        <th scope="col" *ngFor="let head of HasCampiNonModificabili()">{{head.nome}}</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of CheckListList; let i = index">
        <td class="align-middle" *ngIf="!isNewView">
          <input [(ngModel)]="item.risposta" [disabled]="campoUtility.Disable(campoAggiuntivo, Oggetto)" type="checkbox" (ngModelChange)="checkChange(item)" >
        </td>
        <td class="align-middle" >
          <span>
            {{ item.check}}
          </span>
        </td>
        <td class="align-middle" *ngIf="hasCampiAggiuntiviCheckbox(CheckList)">
           <app-field-viewer [(Oggetto)]="CheckListList[i]" [Campi]="CampiModificabili(item)" (OnChange)="Change($event)" [(DropdownSources)]="DropdownSources"></app-field-viewer>
        </td>
        <td *ngFor="let head of HasCampiNonModificabili()">
          <app-field-viewer [(Oggetto)]="CheckListList[i]" [Campi]="CampiNonModificabili(item, head)" [hideLabel]="true"  (OnChange)="Change($event)" [(DropdownSources)]="DropdownSources"></app-field-viewer>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
